<template>
  <div class="magazine-box">
    <div class="magazine-img">
      <a v-if="pathCheck" href="#" @click.prevent="getDocumentID(data.Id)">
        <img v-if="data.Picture" :src="data.Picture" :alt="data.Title" />
        <img v-else src="@/assets/images/magazine_default.jpg" :alt="data.Title" />
      </a>
      <!-- <a v-else :href="`/dath/plan?Id=${data.Id}`">
        <img :src="data.Image" :alt="data.Title" />
      </a> -->
      <a v-else href="#" @click.prevent="getPlanID(data.Id)">
        <img v-if="data.Picture" :src="data.Picture" :alt="data.Title" />
        <img v-else src="@/assets/images/magazine_default.jpg" :alt="data.Title" />
      </a>
    </div>
    <a v-if="pathCheck" href="#" @click.prevent="getDocumentID(data.Id)">
      <div class="magazine-text">
        <div class="magazine-text-date">
          <div class="magazine-text-date-month">
            <div class="day">{{day}}</div>
            <div class="month">{{month}}</div>
          </div>
          <div class="magazine-text-date-year">{{year}}</div>
        </div>
        <h3>{{ data.Title }}</h3>
      </div>
    </a>
    <a v-else href="#" @click.prevent="getPlanID(data.Id)">
      <div class="magazine-text">
        <div class="magazine-text-date">
          <div class="magazine-text-date-month">
            <div class="day">{{day}}</div>
            <div class="month">{{month}}</div>
          </div>
          <div class="magazine-text-date-year">{{year}}</div>
        </div>
        <h3>{{ data.Title }}</h3>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    from: {
      type: String,
    },
  },
  data() {
    return {
      pathCheck: false,
    };
  },
  methods: {
    getDocumentID(id) {
      const vm = this;
      vm.$store.commit('FROM', vm.from);
      vm.$router.push(`/magazine/document/${id}`);
    },
    getPlanID(id) {
      const vm = this;
      // vm.$router.push(`/plan/planId/${id}`);
      vm.$router.push(`/healthEducation/magazine/${id}`);
    },
  },
  computed: {
    day() {
      const vm = this;
      const tmpDay = vm.$moment(vm.data.StartOn).format('DD');
      return tmpDay;
    },
    month() {
      const vm = this;
      let tmpMonth = vm.$moment(vm.data.StartOn).format('MM');
      switch (tmpMonth) {
        case '01':
          tmpMonth = 'JAN';
          break;
        case '02':
          tmpMonth = 'FEB';
          break;
        case '03':
          tmpMonth = 'MAR';
          break;
        case '04':
          tmpMonth = 'APR';
          break;
        case '05':
          tmpMonth = 'MAY';
          break;
        case '06':
          tmpMonth = 'JUN';
          break;
        case '07':
          tmpMonth = 'JUL';
          break;
        case '08':
          tmpMonth = 'AUG';
          break;
        case '09':
          tmpMonth = 'SEP';
          break;
        case '10':
          tmpMonth = 'OCT';
          break;
        case '11':
          tmpMonth = 'NOV';
          break;
        case '12':
          tmpMonth = 'DEC';
          break;

        default:
          break;
      }
      return tmpMonth;
    },
    year() {
      const vm = this;
      const tmpYear = vm.$moment(vm.data.StartOn).format('YYYY');
      return tmpYear;
    },
    fromPath() {
      return this.$store.getters.from;
    },
  },
  created() {
    // console.log(this.data.StartOn.split('-'));
    const vm = this;
    if (vm.$route.path === '/magazine') {
      vm.pathCheck = true;
    }
  },
};
</script>

<style lang="scss">
.magazine-box {
  width: 33.33333%;
  max-width: 325px;
  padding: 1.5rem;

  @media (max-width: 1024px) {
    padding: 1rem;
  }

  @media (max-width: 768px) {
    width: 50%;
  }
  @media (max-width: 420px) {
    width: 100%;
  }
  a {
    text-decoration: none;
  }

  .magazine-img {
    margin-bottom: 1.5rem;
    a {
      display: block;
      border: 1px solid #f1f1f1;
      box-shadow: 5px 4px #f5f5f5;
      transition: all 0.5s;

      img {
        max-height: 493px;
        display: block;
        width: 100%;
      }
    }
  }

  &:hover {
    .magazine-img {
      a {
        transform: translate(2px, 2px);
        box-shadow: 5px 4px #df6c1c;
        border: 1px solid #df6c1c;
        transition: all 0.5s;
      }
    }
    .magazine-text {
      h3 {
        color: #df6c1c;
        transition: all 0.5s;
      }
    }
    .magazine-text-date {
      color: #df6c1c;
      transition: all 0.5s;
    }
  }
}

.magazine-text {
  display: flex;
  h3 {
    font-size: 1.5rem;
    color: #3a3a3a;
    margin-bottom: 0;
    transition: all 0.5s;
  }
}

.magazine-text-date {
  display: flex;
  align-items: center;
  color: #001139;
  transition: all 0.5s;
}

.magazine-text-date-month {
  .day {
    font-size: 2rem;
    line-height: 1;
  }
}

.magazine-text-date-year {
  writing-mode: vertical-lr;
  font-size: 1.3rem;
  margin-right: 2rem;

  @media (max-width: 1024px) {
    margin-right: 1rem;
  }
}
</style>
